export const PROMOTION_REPLY_LIST_PAGE_ITEM_COUNT = 15;

export type GameWeeklyNumber = 1 | 2 | 3 | 4;
export const GAME_WEEKLY_NUMBERS: GameWeeklyNumber[] = [1, 2, 3, 4];

export enum Direction {
  A = 'A',
  B = 'B',
}

export const Directions: Direction[] = [Direction.A, Direction.B];

export const isDirectionValid = (direction?: string): direction is Direction =>
  direction === Direction.A || direction === Direction.B;

export const PromotionKeys = {
  Reply: 'Reply',
  WeeklyReplyCounts: 'WeeklyReplyCounts',
  UserReplies: 'UserReplies',
  UserReplyLikes: 'UserReplyLikes',
  IndexReplyCreatedTimestamp: 'IndexReplyCreatedTimestamp',
  IndexReplyDeletedTimestamp: 'IndexReplyDeletedTimestamp',
  IndexReplyLikes: 'IndexReplyLikes',
} as const;

export type PromotionKey = keyof typeof PromotionKeys;

type BasePromotionKeyParams = {
  promotionId: number;
  promotionItemId: number;
};

export type PromotionKeyParams = {
  [PromotionKeys.Reply]: BasePromotionKeyParams & {
    replyId?: string;
  };
  [PromotionKeys.WeeklyReplyCounts]: BasePromotionKeyParams;
  [PromotionKeys.UserReplies]: BasePromotionKeyParams & {
    userId: number;
  };
  [PromotionKeys.IndexReplyCreatedTimestamp]: BasePromotionKeyParams;
  [PromotionKeys.IndexReplyDeletedTimestamp]: BasePromotionKeyParams;
  [PromotionKeys.IndexReplyLikes]: BasePromotionKeyParams;
  [PromotionKeys.UserReplyLikes]: {
    promotionId: number;
    userId: number;
  };
};

export type PromotionKeyGenerator<T extends PromotionKey> = (params: PromotionKeyParams[T]) => string;

export const PromotionWeeklyKeywords: Record<GameWeeklyNumber, Record<Direction, string>> = {
  1: {
    A: '#오메가버스',
    B: '#가이드버스',
  },
  2: {
    A: '#첫사랑',
    B: '#소꿉친구',
  },
  3: {
    A: '#나이차이',
    B: '#신분차이',
  },
  4: {
    A: '#사건물',
    B: '#일상물',
  },
} as const;

export const getGameKeyword = (week: GameWeeklyNumber, direction: Direction) => {
  const keyword = PromotionWeeklyKeywords[week][direction];
  if (!keyword) {
    throw new Error(`Invalid promotion keyword: ${keyword}`);
  }
  return keyword;
};

export const PromotionItemKeys: Record<string, GameWeeklyNumber> = {
  '/promotion/2025-balance-ritto/1': 1,
  '/promotion/2025-balance-ritto/2': 2,
  '/promotion/2025-balance-ritto/3': 3,
  '/promotion/2025-balance-ritto/4': 4,
} as const;

export const getGameWeeklyNumberByItemKey = (key: string): GameWeeklyNumber => {
  if (!(key in PromotionItemKeys)) {
    throw new Error(`Invalid promotion item key: ${key}`);
  }
  return PromotionItemKeys[key];
};

export const getGameWeeklyKeyByWeek = (week: GameWeeklyNumber) => `/promotion/2025-balance-ritto/${week}`;

export const getLatestGameWeeklyNumber = (weeks: GameWeeklyNumber[]): GameWeeklyNumber | null =>
  weeks.length > 0 ? (Math.max(...weeks) as GameWeeklyNumber) : null;
